export enum ENavigationGuardTypes {
  public = 'public',
  private = 'private',
  authentication = 'authentication',
  authenticationDashboard = 'authenticationDashboard',
}

export enum EPhoneKind {
  mobile = 'mobile',
  homephone = 'homephone',
}

export enum EAddressKind {
  home = 'home',
}

export enum ECustomerKind {
  pf = 'pf',
  pj = 'pj',
}

export enum EPaymentMethod {
  pix = 'pix',
  picpay = 'picpay',
  atarpay = 'atarpay',
  mercadopago = 'mercadopago',
  bankSlip = 'bankslip',
  creditCard = 'creditcard',
  storeCredit = 'store-credit',
  empiricusRewards = 'rewards',
  wireTransfer = 'wiretransfer',

  // additional
  creditCardPix = 'creditcard_pix',
}

export enum EPaymentMethodTypes {
  pix = 'pix',
  bankSlip = 'bankSlip',
  creditCard = 'creditCard',
  storeCredit = 'storeCredit',
  wireTransfer = 'wireTransfer',
  empiricusRewards = 'empiricusRewards',

  // additional
  creditCardPix = 'creditCardPix',
}

export enum ECheckoutStep {
  none = 0,
  authentication = 1,
  payment = 2,
  confirmation = 3,
  renewal = 4,
}

export enum EAvailabilityRedirect {
  redirect_url = 'redirect_url',
  redirect_slug = 'redirect_slug',
}

export enum EEligibilityAction {
  reject = 'reject',
  purchase = 'purchase',
  purchaseRebuy = 'purchase-rebuy',
  purchaseUpgrade = 'purchase-upgrade',
  earlyRenewal = 'early_renewal',
  lateRenewal = 'late_renewal',
}

export enum ECardStep {
  new = 'new',
  select = 'select',
}

export enum EModalType {
  error = 'error',
  warning = 'warning',
  success = 'success',
}

export enum EModalTransition {
  default = 'dialog-transition',
  bottom = 'dialog-bottom-transition',
}

export enum EDevice {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export enum EOrderSuccessPages {
  default = 'default',
  orderConfirmed = 'orderConfirmed',
  orderWaitingPayment = 'orderWaitingPayment',
  renewConfirmed = 'renewConfirmed',
  renewWaitingPayment = 'renewWaitingPayment',
}

export enum EOrderStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  processing = 'processing',
  success = 'success',
  'waiting-for-payment' = 'waiting-for-payment',
}

export enum EErrorOrigin {
  ECOMM_MS_PAYMENTS = 'ECOMM_MS_PAYMENTS',
  ECOMM_MS_COMMERCE = 'ECOMM_MS_COMMERCE',
}

export enum EErrorOriginTransform {
  ECOMM_MS_PAYMENTS = 'payment',
  ECOMM_MS_COMMERCE = 'commerce',
}

export enum EErrorType {
  general = 'general',
  loading = 'loading',
  payment = 'payment',
  eligibility = 'eligibility',
  availability = 'availability',
  authentication = 'authentication',
  rewards = 'rewards',
  loadingTerms = 'loadingTerms',
}

export enum EErrorSeverity {
  info = 'info',
  warning = 'warning',
  critical = 'critical',
}

export enum EErrorBlock {
  all = 'all',
  none = 'none',
}

export enum EErrorExhibition {
  modal = 'modal',
  alert = 'alert',
  none = 'none',
}

export enum EErrorScope {
  login = 'login',
  global = 'global',
  payment = 'payment',
  register = 'register',
}

export enum EAuthenticationAction {
  login = 'login',
  loginAs = 'loginAs',
  logout = 'logout',
  register = 'register',
}

export enum EAuthenticationType {
  manual = 'manual',
  automatic = 'automatic',
}

export enum EAuthenticationOrigin {
  login = 'login',
  register = 'register',
  logout = 'logout',
  guard = 'guard',
}

export enum EAuthenticationTokenStatus {
  valid = 'valid',
  invalid = 'invalid',
  unreadable = 'unreadable',
  inexistent = 'inexistent',
  removed = 'removed',
}

export enum EIntervalTypes {
  days = 'days',
  weeks = 'weeks',
  months = 'months',
  trimesters = 'trimesters',
  semesters = 'semesters',
  years = 'years',
  lifelong = 'lifelong',
}
